const initialState = {
  loading: false,
  patchItems: [],
  errors: {},
};

const defaultInstallerPay = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'DEFAULT_INSTALLER_PAY_REQUEST':
      return { ...state, loading: true };
    case 'DEFAULT_INSTALLER_PAY_SUCCESS':
      return { ...state, loading: false, patchItems: payload.patch_items };
    case 'UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS':
      return {
        ...state,
        loading: false,
        patchItems: state.patchItems.map(item => (
          item.id === payload.patch_item.id ? payload.patch_item : item)),
      };
    case 'BULK_UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS': {
      const updatedById = {};
      payload.patch_items.forEach((item) => { updatedById[item.id] = item; });
      return {
        ...state,
        loading: false,
        patchItems: state.patchItems.map(item => updatedById[item.id] || item),
      };
    }
    case 'DEFAULT_INSTALLER_PAY_FAILURE':
    case 'UPDATE_DEFAULT_INSTALLER_PAY_FAILURE':
    case 'BULK_UPDATE_DEFAULT_INSTALLER_PAY_FAILURE':
      return { ...state, loading: false, errors: payload };
    default:
      return state;
  }
};

export default defaultInstallerPay;



// WEBPACK FOOTER //
// ./client/app/reducers/default_installer_pay.js